import moment from 'moment/moment'
import { EUROPEAN_DATE, getTimezoneLessMoment } from '../momentjs'

export const getOriginalName = file => file.originalName
export const getExtension = file => file.extension
export const getCreatedAt = file => moment.tz(file.createdAt.date, file.createdAt.timezone).format(EUROPEAN_DATE)

export class InstitutionDocument {
  constructor ({ id = -1, originalName = null, mimeType = null, extension = null, size = null, institution = null, createdAt = moment() } = {}) {
    this.id = id
    this.originalName = originalName
    this.mimeType = mimeType
    this.extension = extension
    this.size = size
    this.institution = institution
    this.createdAt = getTimezoneLessMoment(createdAt)
  }

  toRequestBody = () => {
    const body = { ...this }

    body.institution = body.institution === null ? null : body.institution.id

    return body
  }
}
